import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import apiService from '../../services/api.service'
import { messageActions } from '../../store/message'

const BASE_PATH = '/lottustech/movimentoestoque'
const crud = build(validate, BASE_PATH)
const prefix = 'crudMovimentoEstoque'

const newTypes = {
  RESET: `${prefix}reset`,
  ADD_ITEM: `${prefix}addItem`,
  SET_ITEM: `${prefix}setItem`,
  ON_CLICK_REMOVE_ITEM: `${prefix}onClickRemoveItem`,
  SET_SALDO_ESTOQUE: `${prefix}setSaldoEstoque`,
  SET_UNIDADES: `${prefix}setUnidades`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}
actions.addItem = (payload) => {
  return {
    type: types.ADD_ITEM,
    payload,
  }
}

actions.setItem = (prop, value) => {
  return {
    type: types.SET_ITEM,
    prop,
    value,
  }
}

actions.onClickRemoveItem = (payload) => {
  return {
    type: types.ON_CLICK_REMOVE_ITEM,
    payload,
  }
}

actions.setSaldoEstoque = (payload) => {
  return {
    type: types.SET_SALDO_ESTOQUE,
    payload,
  }
}

actions.setUnidades = (payload) => {
  return {
    type: types.SET_UNIDADES,
    payload,
  }
}

actions.gerarRemessa = (data) => {
  return (dispatch, getState) => {
    const path = BASE_PATH + `/gerar`
    return apiService
      .post(path, data)
      .then((response) => {
        dispatch(
          messageActions.messageShowMessages(
            makeMessages(['Remessa enviada com sucesso. Favor aguardar o processamento.']),
            'success'
          )
        )
        dispatch(actions.reset())
      })
      .catch((error) => {
        if (error.response) {
          const messages = error.response.data
          dispatch(messageActions.messageShowMessages(makeMessages([messages]), 'error'))
        }
      })
  }
}

actions.getSaldoEstoque = ({ oidUnidadeOrigem, oidProduto }) => {
  return (dispatch, getState) => {
    const path = BASE_PATH + `/${oidProduto}/saldo/${oidUnidadeOrigem}`
    return apiService
      .get(path)
      .then((response) => {
        const saldo = response.data
        dispatch(actions.setSaldoEstoque(saldo))
        if (saldo <= 0) {
          const messages = 'Saldo em estoque insuficiente'
          dispatch(messageActions.messageShowMessages(makeMessages([messages]), 'warn'))
        }
      })
      .catch((error) => {
        if (error.response) {
          const messages = 'Não foi possível verificar saldo em estoque'
          dispatch(messageActions.messageShowMessages(makeMessages([messages]), 'error'))
        }
      })
  }
}

actions.inventariarEstoque = ({ params }) => {
  return (dispatch, getState) => {
    return apiService
      .post(`${BASE_PATH}/inventariar`, params)
      .then((response) => {
        dispatch(messageActions.messageShowMessages(makeMessages(['Operação finalizada'], 'success')))
        dispatch(actions.reset())
      })
      .catch((error) => {
        dispatch(messageActions.messageShowMessages(makeMessages([error.response.data], 'error')))
      })
  }
}

actions.transferirEstoque = ({ params }) => {
  return (dispatch, getState) => {
    return apiService
      .post(`${BASE_PATH}/transferir`, params)
      .then((response) => {
        dispatch(messageActions.messageShowMessages(makeMessages(['Operação finalizada'], 'success')))
        dispatch(actions.reset())
      })
      .catch((error) => {
        dispatch(messageActions.messageShowMessages(makeMessages([error.response.data], 'error')))
      })
  }
}

const makeMessages = (messages, type) => {
  let sticky = false
  let summary = ''
  if (type === 'error') {
    summary = ''
    sticky = true
  } else if (type === 'warn') {
    summary = ''
    sticky = true
  }
  return messages.map((message) => {
    return {
      sticky: sticky,
      summary: summary,
      severity: type,
      detail: message,
    }
  })
}
export { types, actions }
